// 400
class BadRequest extends Error {
    constructor(message='Bad Request') {
        super(message)
    }
}

// 401
class NotAuthorized extends Error {
    constructor(message='Not Authorized') {
        super(message)
    }
}

// 404
class NotFound extends Error {
    constructor(message='Not Found') {
        super(message)
    }
}

// 500
class ServerError extends Error {
    constructor(message='Server Error') {
        super(message)
    }
}

// 501
class NotImplemented extends Error {
    constructor(message='Not Implemented') {
        super(message)
    }
}

module.exports = {
    BadRequest,
    NotAuthorized,
    NotFound,
    ServerError,
    NotImplemented
}
